import type { BankQuestionDisplay } from "../types";
import type { RawBankQuestion } from "./rawTypes";
import { toUserRef, toScoringGuide } from "./utils";

export function toBankQuestionDisplay(raw: RawBankQuestion): BankQuestionDisplay {
  return {
    id: raw.id,
    text: raw.text ?? "",
    scoringGuide: toScoringGuide(raw.scoringGuide),
    kssartiTopic: raw.kssartiTopic ?? undefined,
    division: raw.division ?? undefined,
    jobTitle: raw.jobTitle ?? undefined,
    addedBy: toUserRef(raw.addedBy),
    updatedBy: raw.updatedBy ? toUserRef(raw.updatedBy) : undefined,
    createdAt: raw.createdAt ?? "",
    updatedAt: raw.updatedAt ?? "",
  };
}
